//
//
//

import { getCookie, setCookie, removeCookie } from "../common/js/utils";
import router from "../router/index.js";
export default {
  directives: {},
  created() {
    let self = this;
    let user = getCookie("user");
    let redirect = getCookie("redirect");
    if (redirect && redirect.indexOf("lottery") > -1) {
    } else {
      if (user) {
        user = JSON.parse(user);
        if (
          user.phoneCertification == 0 &&
          location.href.indexOf("lottery") == -1
        ) {
          // window.location.href = ''
          self.$router.replace({ path: "/mobileAuth" });
        }
      }
    }
    // console.log(user)
    if (redirect) {
      //跳转至支付宝
      if ( /AlipayClient/.test(window.navigator.userAgent)  && redirect.indexOf('/#/yue') > -1 ) {
        let activityId = getCookie( 'activityId' );
        removeCookie("redirect");
        removeCookie("yueBirdredirect");
        removeCookie("yueredirect");
        if( activityId ){
          window.location = window.location.origin+"/#/yueIndex?activityId"+activityId;
        }else{
          window.location = window.location.origin+"/#/yueIndex";
        }
      }
      // if (redirect.indexOf("lottery") == -1) {
      //   removeCookie("redirect");
      // }

       if(redirect.indexOf('yueIndex') > -1) {
          removeCookie("redirect");
          const jumpUrl = redirect.split('#')[1]
          self.$router.replace({ path: jumpUrl })
        } else {
          let yueBirdredirect = getCookie("yueBirdredirect");
          if( yueBirdredirect!=null && yueBirdredirect!='' ){
            removeCookie("yueBirdredirect");
            removeCookie("redirect");
            const jumpUrl = yueBirdredirect.split('#')[1]
            self.$router.replace({ path: jumpUrl })
          }
          removeCookie("redirect");
          window.location.href = redirect;
        }
    } else {
      window.location.href = "/";
    }
   }
};



// WEBPACK FOOTER //
// ./src/components/LoginSuccess.vue